import translating from './translate.json';

const fields = () => {
  return [
    {
      name: 'name',
      label: translating.name,
      required: true
    },
    {
      name: 'minValue',
      label: translating.minValue,
      breakLine: true,
      width: '100px'
    },
    {
      name: 'maxValue',
      label: translating.maxValue,
      type: 'number',
      width: '100px'
    },
    {
      name: 'minNormalValue',
      label: translating.minNormalValue,
      type: 'number',
      width: '100px',
      default: null
    },
    {
      name: 'maxNormalValue',
      label: translating.maxNormalValue,
      type: 'number',
      width: '100px'
    },
    {
      name: 'gender',
      label: translating.gender,
      required: true,
      width: '100px',
      readOnly: true
    },
    {
      name: 'minRedFlagValue',
      label: translating.minRedFlagValue,
      width: '100px',
      default: null
    },
    {
      name: 'maxRedFlagValue',
      label: translating.maxRedFlagValue,
      width: '100px'
    },
    {
      name: 'tool',
      label: translating.tool,
      width: '100px'
    },
    {
      name: 'orderNumber',
      label: translating.orderNumber,
      width: '100px'
    },
    {
      name: 'isRequired',
      label: translating.isRequired,
      type: 'switch'
    },
    {
      name: 'isActive',
      label: translating.isActive,
      type: 'switch'
    }
  ];
};

export default fields;
